import {
  getProcess,
  getSupportedProcessesInfo,
  resolveLatestProcessName,
} from '../transactions/transaction';

// Completion labels and payout metadata do not determine whether the process
// allows a participant's first or second review.
export const canLeaveReview = (transaction, transactionRole) => {
  if (!transaction?.id || !['customer', 'provider'].includes(transactionRole)) {
    return false;
  }

  const processName = resolveLatestProcessName(transaction.attributes?.processName);
  if (!getSupportedProcessesInfo().some(process => process.name === processName)) {
    return false;
  }

  const process = getProcess(processName);
  const state = process.getState(transaction);
  const nextTransitions = process.graph.states[state]?.on || {};
  return [1, 2].some(order =>
    Boolean(nextTransitions[`transition/review-${order}-by-${transactionRole}`])
  );
};
